import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IFetchOffersResult } from "./types";
import { IOffer, serverResponse } from "./validators";

export async function fetchOffers(
  active?: boolean,
): Promise<IFetchOffersResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_ANONYMOUS_GATEWAY_HOST}/offers`,
    {
      validator: serverResponse,
      searchParams: {
        brand: "NJU",
        ...(active && { active }),
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  const dataPackage = result.value.find((offer) => {
    return offer.id === "NJUDataPackage9GB";
  }) as IOffer | undefined;

  const internationalCallsPackages = result.value.filter((offer) => {
    return (
      offer.category === "INTERNATIONAL" &&
      offer.visibility &&
      offer.productSpecificationType === "PRODUCT"
    );
  }) as IOffer[];

  const roamingPackages = result.value.filter((offer) => {
    return (
      offer.category === "ROAMING" &&
      offer.visibility &&
      offer.productSpecificationType === "PRODUCT"
    );
  }) as IOffer[];

  return ok({
    dataPackage,
    internationalCallsPackages,
    roamingPackages,
  });
}
